export default __webpack_public_path__ + "static/media/coversmES.6d2d7be6.jpg";